module.exports = __webpack_public_path__ + "img/backgroundImg.cbf55a92.svg";